export function findNodeIdIndexInArray(array: any[], id: string | number): number {
  if (!Array.isArray(array)) return -1;
  const index = array.findIndex((item) => item.nodeId == id);
  return index;
}
export function findIdIndexInArray(array: any[], id: string | number): number {
  if (!Array.isArray(array)) return -1;
  const index = array.findIndex((item) => item.id == id);
  return index;
}
export function getResourcesFileNames(array: any[]): string[] {
  let fileNames = [];
  for (let file of array) {
    fileNames.push(file.fileName.split('.').slice(0, -1).join('.'));
  }
  return fileNames;
}
export function getResourcesUniqNames(array: any[]): string[] {
  return [...new Set(array)];
}
export function collectFiles(array: any[]): any[] | null {
  if (array == null) return null;
  let resourcesFileNames = getResourcesFileNames(array);
  let uniqFileNames = getResourcesUniqNames(resourcesFileNames);
  let isResourceDuplicatesPresent = resourcesFileNames.length != uniqFileNames.length;
  if (isResourceDuplicatesPresent) {
    let newArr = [];
    for (let uniqName of uniqFileNames) {
      let filteredResources = array.filter((resource: any) => resource.fileName.split('.').slice(0, -1).join('.') == uniqName);
      if (filteredResources.length < 2) {
        filteredResources[0].extensions = [filteredResources[0].fileName.split('.').pop()];
        filteredResources[0].fileIds = [filteredResources[0].fileId];
        newArr.push(filteredResources[0]);
      } else {
        let fileInfo = '';
        for (let i = 0; i < filteredResources.length; i++) {
          fileInfo += filteredResources[i].fileId + '/';
          fileInfo += filteredResources[i].fileName + ',';
          if (i == 0) {
            filteredResources[i].extensions = [filteredResources[0].fileName.split('.').pop()];
            filteredResources[i].fileIds = [filteredResources[0].fileId];
          } else {
            filteredResources[0].extensions.push(filteredResources[i].fileName.split('.').pop());
            filteredResources[0].fileIds.push(filteredResources[i].fileId);
            if (i == filteredResources.length - 1) {
              filteredResources[0].extensions.push('zip');
              fileInfo = fileInfo.slice(0, fileInfo.length - 1);
              filteredResources[0].fileIds.push(fileInfo);
            }
          }
        }
        newArr.push(filteredResources[0]);
      }
    }
    return newArr;
  } else {
    let newArr = JSON.parse(JSON.stringify(array));
    for (let resource of newArr) {
      resource.extensions = [resource.fileName.split('.').pop()];
      resource.fileIds = [resource.fileId];
    }
    return newArr;
  }
}
